import { render, staticRenderFns } from "./ProductHeroBlock.vue?vue&type=template&id=65c59288&scoped=true&"
import script from "./ProductHeroBlock.vue?vue&type=script&lang=js&"
export * from "./ProductHeroBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProductHeroBlock.vue?vue&type=style&index=0&id=65c59288&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c59288",
  null
  
)

export default component.exports